import { ethers } from 'ethers';

/**
 * 多语言映射，默认是 en -> en,如果有 en-US/en_US -> en 的需求使用此映射
 */
export const LOCALE_MAPPING = {};

/**
 * 支持的 语言
 */
export const LOCALE_NAMES = [
    {
        label: '中文',
        id: 'zh-CN',
    },
    {
        label: 'English',
        id: 'en_US',
    },
    {
        label: '日本語',
        id: 'ja_JP',
    },
    {
        label: '한국어',
        id: 'ko_KR',
    },
] as { label: string; id: string }[];

const AllChains = [
    { confirm: 8, token: 'ETH', rpcUrl: 'https://mainnet.infura.io/v3/1f0e11561a734d3397a00b507bfd5528', chainId: 1, icon: 'ethereum', name: 'Ethereum', explorer: 'https://etherscan.io', label: 'Ethereum', txLink: (tx) => 'https://etherscan.io/tx/' + tx, addressLink: (address) => 'https://etherscan.io/address/' + address },
    {
        confirm: 1,
        token: 'BNB',
        rpcUrl: 'https://bsc-testnet.infura.io/v3/1f0e11561a734d3397a00b507bfd5528',
        chainId: 97,
        icon: 'bnbtest',
        name: 'BSCTest',
        explorer: 'https://testnet.bscscan.com',
        label: 'BNB Chain Test',
        publicRpcUrl: 'https://testnet.bscscan.com',
        txLink: (tx) => 'https://testnet.bscscan.com/tx/' + tx,
        secondaryTokens: [
            { icon: '/images/token/token.svg', address: '0x025a1b1844B2D0b7A6f42a591F8194AC0078f91C' },
            { icon: '/images/token/ctoken.svg', address: '0x2Ed99ab92126Eb1b71DCEAdEAC8602d05911B649' },
        ],
        addressLink: (address) => 'https://testnet.bscscan.com/address/' + address,
    },
    {
        confirm: 3,
        token: 'BNB',
        rpcUrl: 'https://bsc-mainnet.infura.io/v3/1f0e11561a734d3397a00b507bfd5528',
        chainId: 56,
        icon: 'bnb',
        name: 'BSC',
        explorer: 'https://bscscan.com',
        publicRpcUrl: 'https://bsc-dataseed.binance.org',
        label: 'BNB Chain',
        txLink: (tx) => 'https://bscscan.com/tx/' + tx,
        secondaryTokens: [
            { icon: '/images/token/token.svg', address: '0x621Fc424c4DD8B7c071D220b7dC249CB8A809d5b' },
            { icon: '/images/token/ctoken.svg', address: '0x4c3256856dC2326712b6AA315cF7d2Fc683D804b' },
        ],
        addressLink: (address) => 'https://bscscan.com/address/' + address,
    },
] as WalletChain[];

const CurAllChain = import.meta.env.VITE_CHAIN_LIST?.split(',') as string[];

export const SupportChains = AllChains.filter((o) => CurAllChain.includes(o.name));

export const AppHostURL = (import.meta.env.VITE_APP_HOST_URL?.trim() || (typeof window !== 'undefined' ? window.location.origin : '') || import.meta.env.VITE_APPLICATION_HOST) as string;

/**
 * 计算默认chain
 */
export const DEFAULT_CHAIN = SupportChains.filter((o) => o.name == (import.meta.env.VITE_CHAIN_NAME ? import.meta.env.VITE_CHAIN_NAME : 'Ethereum'))[0] as WalletChain;

export const NetworkContextName = 'NETWORK';

export const FindChain = (chainId: number): WalletChain => SupportChains.filter((o) => o.chainId == chainId)[0] as WalletChain;
/**
 * AG 总供应量
 */
export const TotalAGDSupply = ethers.utils.parseUnits('100000000', 'ether');
